export const Spray = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="16" y="8" width="13" height="20" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M20 8V3H25V8" stroke="currentColor" stroke-width="2"/>
<circle cx="22.5" cy="17.4878" r="3.5" stroke="currentColor" stroke-width="2"/>
<rect x="12.5" y="3.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
<rect x="7.5" y="3.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
<rect x="2.5" y="3.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
<rect x="2.5" y="8.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
<rect x="2.5" y="13.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
<rect x="7.5" y="8.5" width="2" height="2" fill="currentColor" stroke="currentColor"/>
</svg>`;
